import {Component, Input} from '@angular/core';
import {ImageService} from '../../service/ImageService';
import { Artist } from 'src/app/model/Artist';
import { AlbumSummary } from 'src/app/model/AlbumSummary';

@Component({
  selector: 'app-album-card',
  templateUrl: './album-card.component.html',
  styleUrls: ['./album-card.component.scss']
})
export class AlbumCardComponent {

  @Input() album: AlbumSummary;
  @Input() artist: Artist;

  constructor(
    private imageService: ImageService
  ) {
  }

  getAlbumImg(artistId: string, albumId: string): string {
    return this.imageService.getSmallAlbumCoverImg(artistId, albumId);
  }

}
